import React, { useState, useEffect } from "react";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiOrdersService from "../../../core/api/api.ordersService";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import DataGridOrders from "./components/DataGridOrders";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { tools } from "../../../core/utils/tools";
import { useLocation, useNavigate } from "react-router-dom";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";

const CanceledOrderService = () => {
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  let location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
    (async () => {
      try {
        const response2 = await ApiBasketItemPerson.getEnumType();
        let cancelStatusList = [];
        cancelStatusList.push({
          id: 10,
          title: "همه کنسلی ها",
        });
        if (response2.data != null) {
          response2.data.type.forEach((element, index) => {
            cancelStatusList.push({
              id: index + 1,
              title:
                element === "درخواست_کنسلی"
                  ? "جدید"
                  : element === "کنسل_شد"
                    ? "انجام شد"
                    : element === "رد_درخواست_کنسلی"
                      ? "انجام نشده"
                      : element,
            });
          });
        }
        setbasketCancelStatus(cancelStatusList);
        setValue("cancelStatus", { value: 10, label: "همه کنسلی ها" });
        //////***************************** */
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
          ? _.toNumber(pageNumberFromUrl1)
          : getValues("pageNumber");
        const data = await ApiOrdersService.getBasketCanceledOrder({
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          basketId: searchParams.get("basketId"),
          cancelStatus: _.toString(searchParams.get("cancelStatus")),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "basketId", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          { name: "cancelStatus", type: "multiSelect", isMulti: false, data: cancelStatusList },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
        const queryParamsObj = getValues()
        if (queryParamsObj.cancelStatus) queryParamsObj.cancelStatus = queryParamsObj.cancelStatus.value
        var queryString = tools.createQueryStringFromFromData(_.omit(queryParamsObj, ["totalPages", "totalCount"]));
        navigate(`${location.pathname}?${queryString}`);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);
  const onSubmit = async (data) => {
    if (!_.isEmpty(data.basketId) && !validateNumber(data.basketId)) return;
    if (data.cancelStatus?.length > 0) data.cancelStatus = data.cancelStatus[0].value;
    else data.cancelStatus = data.cancelStatus.value;
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiOrdersService.getBasketCanceledOrder(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/canceled?${queryString}`);
  };
  function handleChangeMultiCityCancelStatus(value) {
    setValue("cancelStatus", value);
  }
  const [basketCancelStatus, setbasketCancelStatus] = useState([]);
  const validateNumber = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketId", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketId");
      return true;
    }
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت کنسلی</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست سرویس های کنسلی ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <span className="badge badge-primary mx-1 font-weight-bold font-size-sm" style={{ backgroundColor: "#3699ff" }}>
              جدید/رهاسازی
            </span>
            <span
              className="badge mx-1 font-weight-bold font-size-sm"
              style={{ color: "#fff", backgroundColor: "rgb(182 206 232)" }}
            >
              درحال پیگیری
            </span>
            <span
              className="badge mx-1 font-weight-bold font-size-sm"
              style={{ backgroundColor: "rgb(64 144 3 / 47%)" }}
            >
              انجام شد
            </span>
            <span
              className="badge mx-1 font-weight-bold font-size-sm"
              style={{ backgroundColor: "rgb(213 94 1 / 52%)" }}
            >
              انجام نشده
            </span>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="">
                  <Accordion>
                    <Card>
                      <Accordion.Header as={Card.Header} variant="link">
                        <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Card.Body>
                          <Row>
                            <Col sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="firstName"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <TextField
                                    label="نام"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    value={value || ""}
                                    onInput={onChange}
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="lastName"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <TextField
                                    label="نام خانوادگی"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    value={value || ""}
                                    onInput={onChange}
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="basketId"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    customInput={TextField}
                                    label="شماره سفارش"
                                    size="small"
                                    margin="normal"
                                    type="search"
                                    value={value || ""}
                                    variant="outlined"
                                    error={!!errors.basketId}
                                    onValueChange={(values) => {
                                      onChange(values.value || "");
                                      validateNumber(values.value);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                  />
                                )}
                              />
                              {errors.basketId && (
                                <div className="text-small-1 text-danger"> {errors.basketId.message}</div>
                              )}
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="phoneNumber"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    customInput={TextField}
                                    label="شماره موبایل"
                                    size="small"
                                    margin="normal"
                                    value={value || ""}
                                    type="search"
                                    variant="outlined"
                                    onChange={onChange}
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                  />
                                )}
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="cancelStatus"
                                control={control}
                                rules={{ required: "لطفاً وضعیت کنسلی را انتخاب کنید" }} // Validation rule for required field
                                render={({ field: { value, onChange }, fieldState: { error } }) => (
                                  <>
                                    <SelectComponent
                                      className="w-100 mt-5"
                                      placeholder="وضعیت کنسلی"
                                      options={basketCancelStatus.map((item) => ({
                                        value: item.id,
                                        label: `${item.id} - ${item.title}`,
                                      }))}
                                      field={{ value, onChange }}
                                      value={value || 10}
                                      onChange={handleChangeMultiCityCancelStatus}
                                    />
                                    {error && <p style={{ color: "red" }}>{error.message}</p>}
                                  </>
                                )}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12" className="tb-reponsive px-2 mt-3">
                              <Button variant="success" type="submit" disabled={isSubmitting}>
                                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                                <SearchIcon />
                                جستجو
                              </Button>{" "}
                              <Button
                                className="ml-3"
                                variant="light-danger"
                                type="submit"
                                disabled={isSubmitting}
                                onClick={() => {
                                  tools.handleResetAdvanceSearchBox(watch, reset);
                                  setValue("cancelStatus", { value: 10, label: "همه کنسلی ها" });
                                }}
                              >
                                <i className="fas fa-refresh text-small"></i>
                                حذف جستجو{" "}
                              </Button>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Accordion.Body>
                    </Card>
                  </Accordion>
                  <InputGroup className="my-3">
                    <Controller
                      name="globalSearch"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <GlobalFormControl
                          type="text"
                          aria-describedby="basic-addon1"
                          placeholder="جستجو ..."
                          name="globalSearch"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                    <Button variant="secondary" type="submit" disabled={isSubmitting}>
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </div>
                <Col xs="12" className="tb-reponsive px-0 mt-3">
                  <DataGridOrders data={listData} />
                </Col>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanceledOrderService;
